import { render, staticRenderFns } from "./AssetPostingList.vue?vue&type=template&id=67b353d9&"
import script from "./AssetPostingList.vue?vue&type=script&lang=js&"
export * from "./AssetPostingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports